
import Navbar from './Navbar/index.js'
import News from './News/index.js'
import Hero from './Hero/index.js'
import WhoAreWe from './WhoAreWe/index.js'
import Instalation from './Instalations/index.js'
import WhatWeDo from './WhatWeDo/index.js'
import Schedule from './Schedule/index.js'
import Price from './Price/index.js'
import Insta from './Insta/index.js'
import Contact from './Contact/index.js'
import Footer from './Footer/index.js'

const components = {
    Navbar,
    News,
    Hero,
    WhoAreWe,
    Instalation,
    WhatWeDo,
    Schedule,
    Price,
    Insta,
    Contact,
    Footer
}

export default components